import * as React from 'react';
import { withRouter, Link, Redirect } from 'react-router-dom';
import bindAllOfThis from "src/utils/BindThisHelper"; // 'this' binder
import Routes from 'src/core/Routes';
import { Translate, withLocalize, LocalizeContextProps } from 'react-localize-redux';

import DataTable, {
    DataTableColumnProps,
    Renderer,
    Filterer,
    DataTableButton,
    DataTableButtonReset
} from 'src/components/common/DataTable';

import TableRequestDTO from 'src/models/datatable/TableRequestDTO';
import TableResponseDTO from 'src/models/datatable/TableResponseDTO';
import ActivityQuestionDTO from 'src/models/activity/ActivityQuestionDTO';
import ActivityApiController from 'src/api/ActivityApiController';
import { message, Button, Modal, Tooltip } from 'antd';


export interface ActivityQuestionsProps extends LocalizeContextProps {
    activityId: number;
    isSurvey: boolean;
    shouldRefreshTable: boolean;
    updateShouldRefreshTable: () => void;
}

interface ActivityQuestionsState {
    loading: boolean;
    tableRecords: ActivityQuestionDTO[];
    formRedirect: boolean;
}

class ActivityQuestions extends React.Component<ActivityQuestionsProps, ActivityQuestionsState> {
    private dataTableRef: DataTable<ActivityQuestionDTO>;

    constructor(props: ActivityQuestionsProps) {
        super(props);
        bindAllOfThis(this, ActivityQuestions.prototype);

        this.state = {
            tableRecords: [],
            loading: true,
            formRedirect: false
        };
    }

    private deleteActivityQuestion(activityQuestionId: number) {
        let ref = this.dataTableRef;
        let translate: (id: any) => any = this.props.translate;

        Modal.confirm({
            title: translate('admin.activityQuestions.confirmDelete'),
            okText: translate('admin.common.confirmYes'),
            okType: 'danger',
            cancelText: translate('admin.common.confirmNo'),
            onOk() {
                ActivityApiController.deleteActivityQuestion(activityQuestionId).then(result => {
                    message.success(translate('admin.activityQuestions.messageDelete'));
                    ref.refresh();
                }).catch(e => {
                    message.error(this.props.translate('admin.activityQuestions.messageDeleteError'));
                });
            },
        });
    }

    private fetchData(requestState: TableRequestDTO, checkEcho: () => boolean, callback: (response: TableResponseDTO<ActivityQuestionDTO>) => void): void {
        this.setState({ loading: true });

        ActivityApiController.getActivityQuestionTableData(requestState, this.props.activityId)
            .then(results => {
                if (!checkEcho()) {
                    return;
                }

                let tableRecords = results.data.results ? results.data.results : [];

                this.setState({
                    tableRecords: tableRecords,
                    loading: false
                });

                callback(results.data);
            });
    }

    private customTableColumns(): DataTableColumnProps<ActivityQuestionDTO>[] {
        let editLink = (text, record: ActivityQuestionDTO) => Routes.getRoute(Routes.ADMIN_ADD_EDIT_ACTIVITY_QUESTION, this.props.activityId, record.activityQuestionId);

        let columns: DataTableColumnProps<ActivityQuestionDTO>[] = [
            DataTable.StandardColumns.Text('admin.activityQuestions.columnHeader1', 'questionText'),
            DataTable.StandardColumns.Text('admin.activityQuestions.columnHeader2', 'displayOrder'),
            DataTable.StandardColumns.Link('admin.common.editColumnHeader', 'edit', editLink, 'edit'),
            {
                columnProps: {
                    key: 'delete',
                    align: 'center',
                    width: 35,
                    render: (text, record, index) => {
                        return (
                            <Tooltip placement="bottom" title={this.props.translate('admin.common.deleteColumnHeader')} arrowPointAtCenter>
                                <Button shape="circle" icon="delete" onClick={() => this.deleteActivityQuestion(record.activityQuestionId)} />
                            </Tooltip>
                        );
                    }
                }
            }
        ];

        if (!this.props.isSurvey) {
            columns.splice(2, 0, DataTable.StandardColumns.Text('admin.activityQuestions.columnHeader3', 'categoryTitle'));
        }

        return columns;
    }

    render() {
        if (this.state.formRedirect) {
            return <Redirect to={Routes.getRoute(Routes.ADMIN_ADD_EDIT_ACTIVITY_QUESTION, this.props.activityId, 0)} push />;
        } else if (this.props.shouldRefreshTable) {
            this.dataTableRef.refresh();
            this.props.updateShouldRefreshTable();
        }

        return (
            <div>
                <h2>{this.props.translate('admin.activityQuestions.tableHeader')}</h2>
                <DataTable
                    ref={ref => this.dataTableRef = ref}
                    serverSide={true}
                    tableProps={{ rowKey: 'activityQuestionId', loading: this.state.loading }}
                    columns={this.customTableColumns()}
                    data={this.state.tableRecords}
                    fetchData={this.fetchData}
                    buttonBar={[
                        new DataTableButton('admin.activityQuestions.addButton', () => { this.setState({ formRedirect: true }); }),
                        new DataTableButtonReset()
                    ]} />
            </div>
        );
    }
}

export default withLocalize(ActivityQuestions as any) as any;



// WEBPACK FOOTER //
// ./src/pages/admin/ActivityQuestions.tsx